import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import Tooltip from '~/components/Tooltip';

class TextFieldWithTooltip extends React.Component {
  state = {
    hovered: false,
  };

  onMouseEnter = () => this.setState({ hovered: true });

  onMouseExit = () => this.setState({ hovered: false });

  render() {
    const {
      children,
      classes,
      error,
      fullWidth,
      labelValue,
      multiline,
      name,
      onBlur,
      onChange,
      placeholder,
      required,
      select,
      tooltipPlacement,
      tooltipTitle,
      type,
      value,
      wrapperClassName,
    } = this.props;

    const { hovered } = this.state;

    const InputElement = (
      <Input
        id={name}
        value={value}
        onChange={onChange}
        style={{ marginTop: '10px' }}
        onBlur={onBlur}
        type={type || 'text'}
        placeholder={placeholder}
        multiline={multiline}
        error={error}
      />
    );

    return (
      <div
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseExit}
        className={wrapperClassName}>
        <FormControl required={required} fullWidth={fullWidth}>
          <Tooltip
            hovered={hovered}
            classes={classes}
            title={tooltipTitle}
            placement={tooltipPlacement}>
            <InputLabel htmlFor={name} className="normal" shrink={null}>
              {labelValue}
            </InputLabel>
          </Tooltip>

          {select ? (
            <Select value={value} input={InputElement}>
              {children}
            </Select>
          ) : (
            InputElement
          )}
        </FormControl>
      </div>
    );
  }
}

TextFieldWithTooltip.propTypes = {
  classes: PropTypes.object,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  labelValue: PropTypes.string,
  multiline: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  select: PropTypes.bool,
  tooltipPlacement: PropTypes.string,
  tooltipTitle: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

export default TextFieldWithTooltip;
